// Use this for Local Development
 export const WEBSITE_URL = "https://pykin.in";

// Comment out the above and Uncomment the below line before building the files for Production
//export const WEBSITE_URL = "https://" + window.location.hostname;
